<template>
  <div class="box"><slot /></div>
</template>
<script>
import {defineComponent} from "vue";

export default defineComponent({
  name: 'WhiteBoxMain'
})
</script>
<style lang="sass" scoped>
.box
  padding: 32px
</style>
